import { useQuery } from "react-query";
import { axiosClient } from "../services/axiosInstance";

const useGetBanners = (typeBanner, userId) => {
  let filterBanners = typeBanner? `?typeBanner=${typeBanner}&userId=${userId}`: `?userId=${userId}`
  const data = useQuery(["getbanners"], () =>
    axiosClient.post(`NewsAndPromotions/GetNewsAndPromotionsList${filterBanners}`)
  );
  return data;
};
export default useGetBanners;
